import Text from "@amzn/meridian/text";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "src/store/store";
import Chat from "./components/chat/chat";
import "./home.scss";
import { Column, Row } from "@amzn/meridian";

const HomePage = () => {
  const location = useLocation();
  const { firstName } = useAppSelector((state) => state.user);
  const { showResult } = useAppSelector((state) => state.chatSlice);
  const isOnMcpRoute = location.pathname === "/mcp";

  return (
    <Row>
      <Row width={"100%"} alignmentHorizontal="center">
        <Column spacingInset={"none 600"} maxWidth={898}>
          <Column spacing={"500"}>
            {!showResult && (
              <Column spacingInset={"600 none none none"}>
                <Column spacing={"none"} spacingInset={"600 none none none"}>
                  <Text fontFamily="bookerly" type="d50" color="success">
                    Hello {firstName}!
                  </Text>
                  <Text fontFamily="bookerly" type="d50">
                    How can we help you today?
                  </Text>
                </Column>
                <Text type="b200" color="secondary">
                  SAIGE provides general information and is not a substitute for
                  Amazon's official workplace health and safety procedures. This
                  tool does not offer legal advice. For the most accurate and
                  up-to-date information, always refer to the official
                  procedures. Direct any legal questions to your Legal POC.
                </Text>
              </Column>
            )}
            <div className="home">
              <Column className="home__min-container">
                <Chat isOnMcpRoute={isOnMcpRoute} />
              </Column>
            </div>
          </Column>
        </Column>
      </Row>
    </Row>
  );
};

export default HomePage;
